export const LEFT_HAND_RELAXED = [
  {t: [-0.05, -0.08, -0.1], r: [0.5373, 0, 0, 0.8434]},
  {t: [-0.0281, -0.0594, -0.1165], r: [0.3943, -0.2036, -0.3103, 0.8407]},
  {t: [0.0026, -0.0299, -0.1518], r: [0.3476, -0.1049, -0.5285, 0.7674]},
  {t: [0.0169, -0.0181, -0.1728], r: [0.3521, 0.0515, -0.635, 0.6857]},
  {t: [0.0268, -0.0018, -0.1966], r: [0.3521, 0.0515, -0.635, 0.6857]},
  {t: [-0.0369, -0.0541, -0.1121], r: [0.5882, -0.1036, 0.0205, 0.8018]},
  {t: [-0.024, 0.0143, -0.1465], r: [0.3269, -0.0887, -0.0003, 0.9409]},
  {t: [-0.0172, 0.0394, -0.1765], r: [-0.0114, -0.0813, -0.0286, 0.9962]},
  {t: [-0.0138, 0.0388, -0.1986], r: [-0.1994, -0.0379, -0.0372, 0.9785]},
  {t: [-0.0125, 0.0287, -0.2199], r: [-0.1994, -0.0379, -0.0372, 0.9785]},
  {t: [-0.0499, -0.0528, -0.1125], r: [0.5569, -0.0203, 0.0319, 0.8297]},
  {t: [-0.0496, 0.0131, -0.1445], r: [0.3908, -0.0273, 0.1089, 0.9136]},
  {t: [-0.0513, 0.0438, -0.1738], r: [0.0747, -0.0923, 0.0634, 0.9909]},
  {t: [-0.0462, 0.0488, -0.2036], r: [-0.1936, -0.1156, 0.0299, 0.9738]},
  {t: [-0.0404, 0.0387, -0.2253], r: [-0.1936, -0.1156, 0.0299, 0.9738]},
  {t: [-0.0612, -0.0561, -0.1138], r: [0.5095, 0.0572, 0.0274, 0.8581]},
  {t: [-0.0698, 0.0022, -0.1468], r: [0.4396, -0.0068, 0.1748, 0.881]},
  {t: [-0.0751, 0.0329, -0.1719], r: [0.071, -0.0911, 0.1344, 0.9842]},
  {t: [-0.0703, 0.0383, -0.2029], r: [-0.1764, -0.1244, 0.0831, 0.9729]},
  {t: [-0.0641, 0.0302, -0.2227], r: [-0.1764, -0.1244, 0.0831, 0.9729]},
  {t: [-0.0708, -0.0616, -0.1145], r: [0.4571, 0.1437, 0.0457, 0.8765]},
  {t: [-0.0889, -0.0132, -0.148], r: [0.3971, 0.0569, 0.2436, 0.883]},
  {t: [-0.098, 0.0096, -0.1727], r: [0.1604, -0.0085, 0.243, 0.9566]},
  {t: [-0.0997, 0.0171, -0.194], r: [-0.0034, -0.0735, 0.1859, 0.9798]},
  {t: [-0.0979, 0.0165, -0.2131], r: [-0.0034, -0.0735, 0.1859, 0.9798]},
] as const;

export const RIGHT_HAND_RELAXED = [
  {t: [0.05, -0.08, -0.1], r: [0.5373, 0, 0, 0.8434]},
  {t: [0.0279, -0.0592, -0.1167], r: [0.3237, 0.1161, 0.293, 0.8921]},
  {t: [0.0026, -0.0313, -0.158], r: [0.2171, 0.0194, 0.5207, 0.8254]},
  {t: [-0.0042, -0.0219, -0.1837], r: [0.2597, -0.0685, 0.6498, 0.711]},
  {t: [-0.01, -0.0084, -0.2107], r: [0.2597, -0.0685, 0.6498, 0.711]},
  {t: [0.037, -0.0539, -0.1123], r: [0.5808, 0.1164, -0.0414, 0.8046]},
  {t: [0.0238, 0.0151, -0.147], r: [0.3081, 0.0484, -0.0273, 0.9497]},
  {t: [0.0206, 0.0393, -0.1786], r: [-0.0461, 0.0526, -0.0104, 0.9975]},
  {t: [0.0185, 0.0373, -0.201], r: [-0.1674, 0.0162, -0.0064, 0.9857]},
  {t: [0.0177, 0.0287, -0.223], r: [-0.1674, 0.0162, -0.0064, 0.9857]},
  {t: [0.05, -0.0527, -0.1126], r: [0.5619, 0.0306, -0.0478, 0.8252]},
  {t: [0.0497, 0.0138, -0.1449], r: [0.353, 0.0474, -0.1014, 0.9289]},
  {t: [0.0491, 0.0425, -0.1767], r: [0.0777, 0.1076, -0.0559, 0.9896]},
  {t: [0.0431, 0.0478, -0.2066], r: [-0.0679, 0.1248, -0.0343, 0.9893]},
  {t: [0.0369, 0.0436, -0.2302], r: [-0.0679, 0.1248, -0.0343, 0.9893]},
  {t: [0.0614, -0.0561, -0.1136], r: [0.5303, -0.05, -0.0384, 0.8455]},
  {t: [0.0699, 0.0028, -0.1472], r: [0.4168, 0.0427, -0.1662, 0.8926]},
  {t: [0.0722, 0.0331, -0.1739], r: [0.1339, 0.1107, -0.1236, 0.977]},
  {t: [0.0665, 0.0425, -0.2041], r: [-0.0175, 0.1318, -0.0809, 0.9878]},
  {t: [0.0606, 0.0413, -0.2257], r: [-0.0175, 0.1318, -0.0809, 0.9878]},
  {t: [0.0711, -0.0618, -0.1145], r: [0.4891, -0.1378, -0.0535, 0.8596]},
  {t: [0.0892, -0.0127, -0.1484], r: [0.3439, 0.0196, -0.23, 0.9102]},
  {t: [0.0924, 0.0087, -0.1761], r: [0.1965, 0.0585, -0.2173, 0.9543]},
  {t: [0.0921, 0.0184, -0.1968], r: [0.0936, 0.1069, -0.1575, 0.9773]},
  {t: [0.0896, 0.0217, -0.2157], r: [0.0936, 0.1069, -0.1575, 0.9773]},
] as const;
